import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    getspotLightData: {},
    spotLightData: {},
    companyList: {},
    activeUserList: {}
}

export const spotLightSlice = createSlice({
    name: 'spotlight',
    initialState,
    reducers: ({
        getspotLightData: (state, action) => {
            state.loading = true
        },
        setGetspotLightData: (state, action) => {
            state.loading = false
            state.getspotLightData = action.payload
        },
        spotLightData: (state, action) => {
            state.loading = true
        },
        setspotLightData: (state, action) => {
            state.loading = false
            state.spotLightData = action.payload
        },
        companyList: (state, action) => {
            state.loading = true
        },
        setcompanyList: (state, action) => {
            state.loading = false
            state.companyList = action.payload
        },
        activeUserList: (state, action) => {
            state.loading = true
        },
        setactiveUserList: (state, action) => {
            state.loading = false
            state.activeUserList = action.payload
        },

    })
})

export const {
    getspotLightData,
    setGetspotLightData,
    spotLightData,
    setspotLightData,
    companyList,
    setcompanyList,
    activeUserList,
    setactiveUserList
} = spotLightSlice.actions

export default spotLightSlice.reducer